document.addEventListener("DOMContentLoaded", function () {
  // Fade in animation for sections
  const fadeInElements = document.querySelectorAll(".product-container");

  // Add fade-in class to all product containers
  fadeInElements.forEach((element) => {
    element.classList.add("fade-in-section");
  });

  // Intersection Observer options
  const observerOptions = {
    threshold: 0.05, // Trigger when 5% of element is visible (faster trigger)
    rootMargin: "0px 0px -20px 0px", // Start animation closer to viewport entry
  };

  // Create intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Get the index of this element for staggered animation
        const elementIndex = Array.from(fadeInElements).indexOf(entry.target);
        const columnDelay = elementIndex * 100; // 100ms between each column

        // Add fade-in class with column delay
        setTimeout(() => {
          entry.target.classList.add("fade-in-visible");

          // Animate text lines within this section after column animation starts
          animateTextLines(entry.target);
        }, columnDelay);

        // Optional: stop observing after animation to improve performance
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Function to animate text lines one by one
  function animateTextLines(container) {
    const textLines = container.querySelectorAll(".animate-text-line");

    textLines.forEach((line, index) => {
      setTimeout(() => {
        line.classList.add("text-visible");
      }, index * 100); // 100ms delay between each line
    });
  }

  // Start observing all fade-in elements
  fadeInElements.forEach((element) => {
    observer.observe(element);
  });

  // Handle variant button clicks
  function handleVariantSelection() {
    const variantButtons = document.querySelectorAll(".variant-button");

    variantButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        // Find the product form container
        const productContainer = this.closest(".product-container");
        if (!productContainer) return;

        // Remove active state from all variant buttons in this product
        const allVariantButtons =
          productContainer.querySelectorAll(".variant-button");
        allVariantButtons.forEach((btn) => {
          btn.classList.remove("border-b-primary");
          btn.classList.add("border-transparent");
        });

        // Add active state to clicked button (selected state with underline)
        this.classList.remove("border-transparent");
        this.classList.add("border-b-primary");

        // Get variant ID from data attribute
        const variantId = this.dataset.variantId;
        const variantTitle = this.dataset.variantTitle;

        // Update the hidden input with selected variant ID
        updateHiddenInput(productContainer, variantId);

        // Enable add to cart button when variant is selected
        enableAddToCartButton(productContainer);

        console.log("Selected variant:", variantTitle, "ID:", variantId);
      });
    });
  }

  // Update the hidden input with selected variant ID
  function updateHiddenInput(productContainer, variantId) {
    const hiddenInput = productContainer.querySelector('input[name="id"]');
    if (hiddenInput && variantId) {
      hiddenInput.value = variantId;
    }
  }

  // Enable add to cart button when variant is selected
  function enableAddToCartButton(productContainer) {
    const addToCartButton = productContainer.querySelector(
      'button[type="submit"]'
    );
    if (addToCartButton) {
      addToCartButton.disabled = false;
      addToCartButton.classList.remove("opacity-50", "cursor-not-allowed");
    }
  }

  // Initialize variant selection
  handleVariantSelection();

  // Set initial state - disable add to cart until variant is selected
  function setInitialVariantState() {
    const productContainers = document.querySelectorAll(".product-container");

    productContainers.forEach((container) => {
      const variantButtons = container.querySelectorAll(".variant-button");
      const addToCartButton = container.querySelector('button[type="submit"]');
      const hiddenInput = container.querySelector('input[name="id"]');

      // Only disable if the product has variant selectors
      if (variantButtons.length > 0) {
        if (addToCartButton) {
          // Disable add to cart button initially
          addToCartButton.disabled = true;
          addToCartButton.classList.add("opacity-50", "cursor-not-allowed");
        }

        if (hiddenInput) {
          // Clear the hidden input value
          hiddenInput.value = "";
        }
      }
      // Products without variants (has_only_default_variant) are left enabled
    });
  }

  // Handle form submission validation
  function handleFormSubmission() {
    const productForms = document.querySelectorAll('form[action*="cart"]');

    productForms.forEach((form) => {
      form.addEventListener("submit", function (e) {
        const productContainer = this.closest(".product-container");
        const variantButtons = productContainer
          ? productContainer.querySelectorAll(".variant-button")
          : [];
        const hiddenInput = this.querySelector('input[name="id"]');

        // Only validate if the product has variant selectors
        if (variantButtons.length > 0) {
          if (!hiddenInput || !hiddenInput.value) {
            e.preventDefault();
            alert("Please select a variant before adding to cart.");
            return false;
          }
        }
        // Products without variants can submit normally
      });
    });
  }

  setInitialVariantState();
  handleFormSubmission();
  loadLayloTourDates();
});

// ===== LAYLO TOUR DATES =====

// Fetch tour dates from Laylo CDN and render them
async function loadLayloTourDates() {
  const container = document.getElementById("laylo-tour-container");
  if (!container) return;

  const username = container.dataset.layloUsername;
  const dropId = container.dataset.layloDropId;

  if (!username || !dropId) return;

  try {
    const response = await fetch(
      `https://d21i0hc4hl3bvt.cloudfront.net/${username}/${dropId}.json`
    );
    if (!response.ok) throw new Error("Failed to fetch Laylo data");

    const data = await response.json();
    const events = (data.orderedSubProducts || []).filter((e) => e.isPublic);

    renderLayloTourDates(container, events);
  } catch (error) {
    console.error("Laylo tour dates error:", error);
  }
}

// Render Laylo tour date events into the container
function renderLayloTourDates(container, events) {
  if (!events.length) return;

  // Get today's date in Pacific Time
  const now = new Date();
  const pacificNow = now.toLocaleString("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const [month, day, year] = pacificNow.split("/").map(Number);
  const today = new Date(year, month - 1, day);

  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  // Group events by year (extract UTC date)
  const eventsByYear = {};
  events.forEach((event) => {
    // Laylo stores dates as midnight UTC, extract the UTC year
    const timestamp = new Date(event.eventDate);
    const y = timestamp.getUTCFullYear();
    if (!eventsByYear[y]) eventsByYear[y] = [];
    eventsByYear[y].push(event);
  });

  const html = Object.keys(eventsByYear)
    .sort((a, b) => a - b)
    .map((year) => {
      const yearEvents = eventsByYear[year]
        .map((event) => {
          // Laylo stores dates as midnight UTC - extract UTC date components
          const timestamp = new Date(event.eventDate);
          const utcYear = timestamp.getUTCFullYear();
          const utcMonth = timestamp.getUTCMonth();
          const utcDay = timestamp.getUTCDate();

          // Create local date with UTC date values for display
          const eventDate = new Date(utcYear, utcMonth, utcDay);
          const isPast = eventDate < today;

          // Format date as "MAR 14"
          const formattedDate = `${months[eventDate.getMonth()]} ${eventDate.getDate()}`;

          // Extract venue from title (everything after "@")
          const titleParts = event.title.split("@");
          const venue = titleParts.length > 1 ? titleParts[1].trim() : "";

          // Location info
          const city = event.location?.name || "";
          const state = event.location?.state?.name || "";
          const country = event.location?.country?.name || "";

          // Build location string: "City, State" or "City, Country"
          let locationLine = city;
          if (state && country === "United States") {
            locationLine = `${city}, ${state}`;
          } else if (country) {
            locationLine = `${city}, ${country}`;
          }

          // Tickets link
          const ticketsUrl = event.link || "";

          return `
            <div class="tour-date flex flex-col gap-y-6${isPast ? " line-through" : ""}">
              <div>${formattedDate.toUpperCase()}</div>
              <div class="flex flex-col items-start gap-y-0 leading-[18px] md:leading-[21px]">
                ${venue ? `<div>${venue.toUpperCase()}</div>` : ""}
                ${locationLine ? `<div>${locationLine.toUpperCase()}</div>` : ""}
              </div>
              ${
                ticketsUrl
                  ? `<div class="skx-xs flex flex-row gap-x-2 font-sans">
                      <a href="${ticketsUrl}" target="_blank" class="text-sm hover:underline">Tickets</a>
                    </div>`
                  : ""
              }
            </div>`;
        })
        .join("");

      return `
        <div class="grid-element-soft-full font-heading flex flex-col items-start gap-y-12">
          <div>${year}</div>
          ${yearEvents}
        </div>`;
    })
    .join("");

  container.innerHTML = html;
}

// ===== CART DRAWER FUNCTIONALITY =====

class CartDrawer {
  constructor() {
    this.drawer = document.getElementById("cart-drawer");
    this.overlay = this.drawer.querySelector(".cart-drawer-overlay");
    this.closeBtn = this.drawer.querySelector(".cart-drawer-close");
    this.itemsContainer = document.getElementById("cart-items");
    this.totalPrice = document.getElementById("cart-total-price");
    this.checkoutBtn = document.getElementById("checkout-btn");

    this.init();
  }

  init() {
    console.log("Initializing cart drawer...");

    // Verify all elements exist
    if (
      !this.drawer ||
      !this.overlay ||
      !this.closeBtn ||
      !this.itemsContainer ||
      !this.totalPrice ||
      !this.checkoutBtn
    ) {
      console.error("Missing cart drawer elements:", {
        drawer: !!this.drawer,
        overlay: !!this.overlay,
        closeBtn: !!this.closeBtn,
        itemsContainer: !!this.itemsContainer,
        totalPrice: !!this.totalPrice,
        checkoutBtn: !!this.checkoutBtn,
      });
      return;
    }

    // Bind event listeners
    this.closeBtn.addEventListener("click", () => this.close());
    this.overlay.addEventListener("click", () => this.close());
    this.checkoutBtn.addEventListener("click", () => this.checkout());

    // Listen for cart open triggers
    document.addEventListener("click", (e) => {
      if (e.target.closest(".skx-cart-open")) {
        console.log("Cart open trigger clicked");
        e.preventDefault();
        this.open();
      }
    });

    // Listen for add to cart events
    document.addEventListener("submit", (e) => {
      if (e.target.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        this.handleAddToCart(e.target);
      }
    });

    // Handle escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.drawer.classList.contains("open")) {
        this.close();
      }
    });

    // Initial load
    this.loadCart();
  }

  async handleAddToCart(form) {
    try {
      const formData = new FormData(form);

      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        await this.loadCart();
        this.open();
        this.updateCartCount();
      } else {
        const error = await response.json();
        alert(error.message || "Error adding item to cart");
      }
    } catch (error) {
      console.error("Add to cart error:", error);
      alert("Error adding item to cart");
    }
  }

  async loadCart() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      this.renderCart(cart);
      this.updateCartCount();
    } catch (error) {
      console.error("Load cart error:", error);
    }
  }

  renderCart(cart) {
    if (cart.items.length === 0) {
      this.itemsContainer.innerHTML =
        '<div class="py-10 px-5 text-center text-white/70">Your cart is empty</div>';
      this.checkoutBtn.disabled = true;
    } else {
      this.itemsContainer.innerHTML = cart.items
        .map((item) => this.renderCartItem(item))
        .join("");
      this.checkoutBtn.disabled = false;

      // Add event listeners to quantity controls
      this.itemsContainer
        .querySelectorAll(".quantity-btn, .remove-item")
        .forEach((btn) => {
          btn.addEventListener("click", (e) => this.handleQuantityChange(e));
        });

      this.itemsContainer
        .querySelectorAll(".quantity-input")
        .forEach((input) => {
          input.addEventListener("change", (e) => this.handleQuantityChange(e));
        });
    }

    this.totalPrice.textContent = this.formatMoney(cart.total_price);
  }

  // <div class="w-full h-0 outline-2 -outline-offset-1 outline-primary"></div>

  renderCartItem(item) {
    return `
      <div class="cart-item border-primary py-6 border-t border-dotted flex flex-row gap-x-5" data-key="${item.key}">
        <img src="${item.image}" alt="${item.title}" class="w-[100px] h-[100px] md:w-[140px] md:h-[140px] object-contain flex-none">
        <div class="min-w-0 skx-xs flex-1 flex flex-col items-start gap-y-4">
          <div class="flex flex-col items-start text-left skx-xs">
            <div class="font-normal wrap-break-word">${item.product_title.toUpperCase()}</div>
            ${
              item.variant_title && item.variant_title !== "Default Title"
                ? `<div class="">${item.options_with_values[0].name}: ${item.variant_title}</div>`
                : ""
            }
            <div class="skx-xs">${this.formatMoney(item.line_price)}</div>
          </div>
          <div class="skx-xs quantity-selector flex flex-row">
            <div class="mr-1">Quantity:&nbsp;</div>
            <button class="quantity-btn minus" data-key="${item.key}" ${item.quantity <= 1 ? "disabled" : ""}>−</button>
            <input id="quantity-${item.key}" type="text" pattern="[0-9]*" inputmode="numeric" class="quantity-input mr-0.5" value="${item.quantity}" min="1" data-key="${item.key}">
            <button class="quantity-btn plus" data-key="${item.key}">+</button>
          </div>
          <button class="bg-transparent appearance-none skx-xs border-none cursor-pointer remove-item" data-key="${item.key}">Remove</button>
        </div>
      </div>
    `;
  }

  async handleQuantityChange(e) {
    const key = e.target.dataset.key;
    let quantity;

    if (e.target.classList.contains("minus")) {
      const input = e.target.nextElementSibling;
      quantity = Math.max(0, parseInt(input.value) - 1);
    } else if (e.target.classList.contains("plus")) {
      const input = e.target.previousElementSibling;
      quantity = parseInt(input.value) + 1;
    } else if (e.target.classList.contains("remove-item")) {
      quantity = 0;
    } else if (e.target.classList.contains("quantity-input")) {
      quantity = Math.max(0, parseInt(e.target.value));
    }

    await this.updateQuantity(key, quantity);
  }

  async updateQuantity(key, quantity) {
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
        }),
      });

      if (response.ok) {
        await this.loadCart();
      }
    } catch (error) {
      console.error("Update quantity error:", error);
    }
  }

  updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const countElements = document.querySelectorAll(".cart-item-count");
        countElements.forEach((el) => {
          el.textContent = cart.item_count;
        });
      });
  }

  open() {
    console.log("Opening cart drawer");
    console.log("Drawer element:", this.drawer);
    console.log("Current classes before:", this.drawer.className);
    this.drawer.classList.add("open");
    console.log("Current classes after:", this.drawer.className);

    // Prevent scrolling on body
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${window.scrollY}px`;
  }

  close() {
    console.log("Closing cart drawer");
    this.drawer.classList.remove("open");

    // Restore scrolling and scroll position
    const scrollY = document.body.style.top;
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
    document.body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }

  // Test function for debugging
  test() {
    console.log("Cart drawer test - toggling visibility");
    if (this.drawer.classList.contains("open")) {
      this.close();
    } else {
      this.open();
    }
  }

  checkout() {
    if (!this.checkoutBtn.disabled) {
      window.location.href = "/checkout";
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(cents / 100);
  }
}

// Function to initialize cart drawer
function initCartDrawer() {
  console.log("DOM loaded, looking for cart drawer...");

  // Make sure the cart drawer element exists before initializing
  const cartDrawerElement = document.getElementById("cart-drawer");
  if (!cartDrawerElement) {
    console.error("Cart drawer element not found in DOM");
    console.log(
      "Available elements with IDs:",
      Array.from(document.querySelectorAll("[id]")).map((el) => el.id)
    );
    return;
  }

  console.log("Cart drawer element found, initializing...");

  try {
    const cartDrawer = new CartDrawer();

    // Make cart drawer globally accessible for debugging and external triggers
    window.cartDrawer = cartDrawer;

    // Add debug functions to window for console testing
    window.debugCart = {
      open: () => cartDrawer.open(),
      close: () => cartDrawer.close(),
      test: () => cartDrawer.test(),
      toggleDebug: () => {
        cartDrawer.drawer.classList.toggle("debug");
        console.log("Debug mode toggled");
      },
    };

    console.log(
      "Cart drawer initialized successfully. Use window.debugCart.open() to test opening."
    );

    // Check if redirected from cart page with auto-open parameter (only for redirects)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("cart") === "open") {
      cartDrawer.open();

      // Clean up the URL parameter
      const url = new URL(window.location);
      url.searchParams.delete("cart");
      window.history.replaceState(
        {},
        document.title,
        url.pathname + url.search
      );
    }
  } catch (error) {
    console.error("Error initializing cart drawer:", error);
  }
}

// Initialize cart drawer when DOM is loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCartDrawer);
} else {
  // DOM is already loaded
  initCartDrawer();
}

// YouTube play button functionality
document.addEventListener("DOMContentLoaded", function () {
  const playButton = document.querySelector(".yt-play-btn");
  const iframe = document.querySelector("iframe");

  if (playButton && iframe) {
    playButton.addEventListener("click", function () {
      const iframeSrc = iframe.src;
      // Add autoplay parameter to the YouTube URL
      if (iframeSrc.includes("?")) {
        iframe.src = iframeSrc + "&autoplay=1";
      } else {
        iframe.src = iframeSrc + "?autoplay=1";
      }
    });
  }
});
